import { render, staticRenderFns } from "./PartidaDetail.vue?vue&type=template&id=ea4125c0&scoped=true"
import script from "./PartidaDetail.vue?vue&type=script&lang=js"
export * from "./PartidaDetail.vue?vue&type=script&lang=js"
import style0 from "./PartidaDetail.vue?vue&type=style&index=0&id=ea4125c0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea4125c0",
  null
  
)

export default component.exports